import { Box, Divider, Typography } from "@mui/material";
import { ReactNode } from "react";

type CustomTitleBoxProps = {
    title: string,
    children: ReactNode | ReactNode[]
}

export default function CustomTitleBox({ title, children }: CustomTitleBoxProps) {

    return (
            <Box style={{color: 'white', marginTop: '1rem', backgroundColor: 'rgba(37,37,37,0.8)', borderRadius: '2rem', paddingBottom: '1rem', paddingRight: '1rem', paddingLeft: '1rem', marginBottom: '1rem' }}>
                <Typography style={{ textAlign: 'center', paddingBottom: '0.8rem', paddingTop: '1rem' }} variant="h5">
                    {title}
                </Typography>
                <Divider variant="middle" sx={{ mb: '0.8rem', bgcolor: 'darkgrey' }} />
                {children}
            </Box>
    );
}